import api from "./client";
import type { LeadPayload } from "@shared/core";

export async function createLead(payload: any) {
  const isFormData =
    typeof FormData !== "undefined" && payload instanceof FormData;

  console.log(payload);

  return await api.request<any>(`/crm/lead`, {
    method: "POST",
    headers: isFormData ? undefined : { "Content-Type": "application/json" },
    body: isFormData ? payload : JSON.stringify(payload),
  });
}
